"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
// This component simply displays the bib details
// It is kept here as it is used in more than one place
function BibDetails(props) {
  const bib = props.cseBib;
  return /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      marginTop: 30
    }
  }, !props.loaded ? 'Loading' : bib.rankingDivisionDescription + ' ' + bib.classDescription + ':' + (bib.bibNumber ? ' Bib ' + bib.bibNumber + ' - ' : ' ') + bib.bibName + ' ' + bib.ageCategoryDescription + (bib.clubName ? ' - ' + bib.clubName : '') + (bib.sponsor ? '/' + bib.sponsor : '') + (bib.countryName ? '/' + bib.countryName : ''));
}
var _ref = {
  classDescription: true,
  rankingDivisionDescription: true,
  bibNumber: true,
  bibName: true,
  ageCategoryDescription: true,
  clubName: true,
  sponsor: true,
  countryName: true
};
var _default = exports.default = (0, _reactBicycle.connect)(BibDetails, props => ({
  ["cseBib(cseBibID:" + JSON.stringify(props.cseBibID) + ")"]: _ref
}), undefined, {
  renderLoading: true
});